import { Grid } from '@mui/material';
import OutlinedInputController from 'controllers/outlined-input-controller';

export const VariantLibraryNameInput = () => {
  return (
    <Grid sx={{ marginBottom: '34px' }}>
      <OutlinedInputController
        fullWidth
        name="name"
        placeholder="Choices Group Name"
        label="Choices Group Name"
        withError
      />
    </Grid>
  );
};
